<template>
   <div class="unenroll-participant-list">
        <div class="row margin-top-3Perc margin-bottom-3Perc">
          <div class="col-md-8 col-lg-6">
            <div class="col-md-12 col-lg-12 text-align-left padding-left-0Point5Perc certification-state-indicator">
              <span v-html="certificateEnableDisableText"></span>
            </div>
          </div>
        </div>
      <div class="table-responsive margin-top-1-perc margin-left-0Point3Perc overflow-y-hidden padding-bottom-18px">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="text-align-center font-size-15px border-right col-xs-1 col-sm-1 col-md-1 col-lg-1"><p class="opacity-0" :class="{'opacity-1': selectedUserIdList.length > 0}">{{selectedUserIdList.length}}</p><p><input type="checkbox" v-model="getIsSelectedAllValue"></p></th>
            <th class="text-align-center font-size-15px border-right col-xs-1 col-sm-1 col-md-1 col-lg-1 padding-left-0px padding-right-0px cursor-pointer">
              <span @click="selectedColumn('EnrollmentDate', 'asc', false)">Enrollment Date</span>
              <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currEnrollmentDateSortOrder === 'desc'}" @click="selectedColumn('EnrollmentDate', 'desc', true)">&#9660;</span>
              <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currEnrollmentDateSortOrder === 'asc'}" @click="selectedColumn('EnrollmentDate', 'asc', true)">&#9650;</span>
            </th>
            <th class="text-align-center font-size-15px border-right col-xs-2 col-sm-2 col-md-2 col-lg-2 cursor-pointer">
              <span @click="selectedColumn('FirstName', 'asc', false)">Participant Name</span>
              <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currFirstNameSortOrder === 'desc'}" @click="selectedColumn('FirstName', 'desc', true)">&#9660;</span>
              <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currFirstNameSortOrder === 'asc'}" @click="selectedColumn('FirstName', 'asc', true)">&#9650;</span>
            </th>
            <th class="text-align-center font-size-15px border-right col-xs-1 col-sm-1 col-md-1 col-lg-1">Platform</th>
            <th class="text-align-center font-size-15px border-right col-xs-1 col-sm-1 col-md-1 col-lg-1">UnEnrolled</th>
            <th class="text-align-center font-size-15px border-right col-xs-1 col-sm-1 col-md-1 col-lg-1">Certified</th>
            <th class="text-align-center font-size-15px border-right padding-left-0px padding-right-0px col-xs-1 col-sm-1 col-md-1 col-lg-1 cursor-pointer">
                <span @click="selectedColumn('UserProgress', 'asc', false)">Progress</span>
                <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currProgressSortOrder === 'desc'}" @click="selectedColumn('UserProgress', 'desc', true)">&#9660;</span>
                <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currProgressSortOrder === 'asc'}" @click="selectedColumn('UserProgress', 'asc', true)">&#9650;</span>
            </th>
            <th class="text-align-center font-size-15px border-right col-xs-1 col-sm-1 col-md-1 col-lg-1">Toolkit</th>
            <th class="text-align-center font-size-15px col-xs-2 col-sm-2 col-md-2 col-lg-2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="UserObj in getAllParticipantsFromSelectedCohort" :key="UserObj.UserId">
            <td class="border-right col-xs-1 col-sm-1 col-md-1 col-lg-1">
              <label><input type="checkbox" :value="UserObj.UserId" v-model="getSelectedUserIdList"></label>
            </td>
            <td class="border-right col-xs-1 col-sm-1 col-md-1 col-lg-1 padding-left-0px padding-right-0px">{{getHumanReadableDate(UserObj.EnrollmentDate)}}</td>
            <td class="border-right col-xs-2 col-sm-2 col-md-2 col-lg-2 padding-left-0px padding-right-0px">
               <div class="tooltip1">
                 {{UserObj.FirstName}} {{UserObj.LastName}}
                <span class="tooltiptext width-auto">Username: {{UserObj.UserName}}</span>
              </div>
            </td>
            <td class="border-right col-xs-1 col-sm-1 col-md-1 col-lg-1 padding-left-0px padding-right-0px">
              <div class="tooltip1">
                <img :src="iOSIconSrc" class="img-responsive element-icon-width-height" alt="ios-icon" v-if="UserObj.iOSVersion !== null && UserObj.iOSVersion.trim().length !== 0"/>
                <span class="tooltiptext text-break" v-if="UserObj.iOSVersion !== null && UserObj.iOSVersion.trim().length !== 0">{{UserObj.iOSVersion}}</span>
              </div>
              <div class="tooltip1">
                <img :src="androidIconSrc" class="img-responsive element-icon-width-height" alt="android-icon" v-if="UserObj.AndroidVersion !== null && UserObj.AndroidVersion.trim().length !== 0"/>
                <span class="tooltiptext text-break" v-if="UserObj.AndroidVersion !== null && UserObj.AndroidVersion.trim().length !== 0">{{UserObj.AndroidVersion}}</span>
              </div>
              <div class="tooltip1">
                <img :src="webIconSrc" class="img-responsive element-icon-width-height" alt="web-icon" v-if="UserObj.WebVersion !== null && UserObj.WebVersion.trim().length !== 0"/>
                <span class="tooltiptext text-break" v-if="UserObj.WebVersion !== null && UserObj.WebVersion.trim().length !== 0">{{UserObj.WebVersion}}</span>
              </div>
            </td>
            <td class="border-right col-xs-1 col-sm-1 col-md-1 col-lg-1 padding-left-0px padding-right-0px">{{UserObj.Unenrolled ? 'Yes' : 'No'}}</td>
            <td class="border-right col-xs-1 col-sm-1 col-md-1 col-lg-1 padding-left-0px padding-right-0px">{{isUserCertificatePresent(UserObj) ? 'Yes' : 'No'}}</td>
            <td class="border-right col-xs-1 col-sm-1 col-md-1 col-lg-1 padding-left-0px padding-right-0px">{{UserObj.UserProgress}}%</td>
            <td class="border-right col-xs-1 col-sm-1 col-md-1 col-lg-1 padding-left-0px padding-right-0px">{{UserObj.ViewToolkit ? 'Yes' : 'No'}}</td>
            <td class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <a class="cursor-pointer" @click="performUserClickAction($event, true, UserObj, 'generate_certificate')" :class="{'opacity-point-2 cursor-default': !isGroupCourseCertificatePresent()}"> Generate Certificate </a>|
              <a class="cursor-pointer" @click="performUserClickAction($event, true, UserObj, 'preview_certificate')" :class="{'opacity-point-2 cursor-default': !isUserCertificatePresent(UserObj)}"> Preview Certificate </a>|
              <a class="cursor-pointer" @click="performUserClickAction($event, true, UserObj, 'allow_disallow_certificate')" :class="{'opacity-point-2 cursor-default': !isUserCertificatePresent(UserObj)}"> {{UserObj.UserCertificate !== undefined && UserObj.UserCertificate !== 'undefined' && UserObj.UserCertificate !== null && UserObj.UserCertificate !== 'null' && UserObj.UserCertificate !== '' && UserObj.UserCertificate.AllowView ? 'Disallow Certificate' : 'Allow Certificate'}} </a>|
              <a class="cursor-pointer" @click="performUserClickAction($event, true, UserObj, 'enrollment')"> {{UserObj.Unenrolled === true ? 'Enroll' : 'UnEnroll'}}  </a>|
              <a class="cursor-pointer" @click="performUserClickAction($event, true, UserObj, 'toolkit')"> {{UserObj.ViewToolkit === true ? 'Remove Toolkit' : 'Allow Toolkit'}} </a>|
              <a class="cursor-pointer" @click="performUserClickAction($event, true, UserObj, 'course')"> {{UserObj.Disallowed === true ? 'Allow Course' : 'Disallow Course'}} </a>|
              <a class="cursor-pointer" @click="performUserClickAction($event, true, UserObj, 'reset_data')"> Reset Data </a>
            </td>  
          </tr>
        </tbody>
    </table>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
    </div>
    <loader></loader>

    <choose-certificate-view-mode v-if="openCertificateViewerOverlay" :userObj="selectedUserObj" @closeOverlay="closeCertificateViewOverlay"></choose-certificate-view-mode>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixWarningString" v-bind:postfixString="postWarningString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performOperation"></confirmation-alert>
  </div>
    </div>    
</template>

<script>
import ChooseCertificateViewMode from '@/components/ChooseCertificateViewMode'
import iOSIconSrc from '../assets/images/mac.svg'
import androidIconSrc from '../assets/images/android.svg'
import webIconSrc from '../assets/images/pc.svg'
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import has from 'lodash/has'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { participantService } from '@/server-util/participant-service'
export default {
  props: ['userObjList', 'selectedCohortObj', 'selectedGCMObj'],
  name: 'unenroll-participant-list',
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      selectedUserObj: null,
      showConfirmationBox: false,
      prefixWarningString: 'Are you sure you want to delete ',
      postWarningString: '?',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      selectedOperation: '',
      isSelectedAll: false,
      totalEnrolledUserCount: 0,
      iOSIconSrc: iOSIconSrc,
      androidIconSrc: androidIconSrc,
      webIconSrc: webIconSrc,
      certificateEnableDisableText: '',
      selectedUserIdList: [],
      currProgressSortOrder: '',
      currFirstNameSortOrder: '',
      currEnrollmentDateSortOrder: '',
      openCertificateViewerOverlay: false
    }
  },
  methods: {
    closeCertificateViewOverlay (value) {
      this.openCertificateViewerOverlay = false
      this.$store.state.isOverlayVisible = false
      this.selectedUserObj = null
    },
    getHumanReadableDate: function (date) {
      return dmAdminUtils.getHumanReadableEST(date + 'Z')
    },
    selectedColumn: function (currSelectedColumn, orderBy = 'asc', clickedOnArrow) {
      var emitVal = false
      switch (currSelectedColumn) {
        case 'EnrollmentDate':
          if (clickedOnArrow) {
            if (this.currEnrollmentDateSortOrder === orderBy) {
              // orderBy = 'desc'
              currSelectedColumn = 'EnrollmentDate'
              // this.currProgressSortOrder = ''
              emitVal = false
            } else {
              this.currEnrollmentDateSortOrder = orderBy
              emitVal = true
            }
          } else {
            if (this.currEnrollmentDateSortOrder === '') {
              orderBy = 'asc'
            } else {
              orderBy = this.currEnrollmentDateSortOrder === 'asc' ? 'desc' : 'asc'
            }
            currSelectedColumn = 'EnrollmentDate'
            this.currEnrollmentDateSortOrder = orderBy
            emitVal = true
          }
          // console.log('emitVal: ' + emitVal)
          if (emitVal) {
            var objToEmit = {
              SortType: orderBy,
              ColumnName: currSelectedColumn
            }
            this.$emit('sortBasedOnColumnName', objToEmit)
          }
          this.currProgressSortOrder = ''
          this.currFirstNameSortOrder = ''
          break
        case 'FirstName':
          if (clickedOnArrow) {
            if (this.currFirstNameSortOrder === orderBy) {
              // orderBy = 'desc'
              currSelectedColumn = 'FirstName'
              // this.currProgressSortOrder = ''
              emitVal = false
            } else {
              this.currFirstNameSortOrder = orderBy
              emitVal = true
            }
          } else {
            if (this.currFirstNameSortOrder === '') {
              orderBy = 'asc'
            } else {
              orderBy = this.currFirstNameSortOrder === 'asc' ? 'desc' : 'asc'
            }
            currSelectedColumn = 'FirstName'
            this.currFirstNameSortOrder = orderBy
            emitVal = true
          }
          // console.log('emitVal: ' + emitVal)
          if (emitVal) {
            objToEmit = {
              SortType: orderBy,
              ColumnName: currSelectedColumn
            }
            this.$emit('sortBasedOnColumnName', objToEmit)
          }
          this.currProgressSortOrder = ''
          this.currEnrollmentDateSortOrder = ''
          break
        case 'UserProgress':
          if (clickedOnArrow) {
            if (this.currProgressSortOrder === orderBy) {
              // orderBy = 'desc'
              currSelectedColumn = 'UserProgress'
              // this.currProgressSortOrder = ''
              emitVal = false
            } else {
              this.currProgressSortOrder = orderBy
              emitVal = true
            }
          } else {
            if (this.currProgressSortOrder === '') {
              orderBy = 'asc'
            } else {
              orderBy = this.currProgressSortOrder === 'asc' ? 'desc' : 'asc'
            }
            currSelectedColumn = 'UserProgress'
            this.currProgressSortOrder = orderBy
            emitVal = true
          }
          // console.log('emitVal: ' + emitVal)
          if (emitVal) {
            objToEmit = {
              SortType: orderBy,
              ColumnName: currSelectedColumn
            }
            this.$emit('sortBasedOnColumnName', objToEmit)
          }
          this.currFirstNameSortOrder = ''
          this.currEnrollmentDateSortOrder = ''
          break
      }
    },
    setDefaultValues: function () {
      this.certificateEnableDisableText = this.isGroupCourseCertificatePresent() ? 'Certification system is <b><u>enabled</u></b> for this group course.' : 'Certification system is <b><u>not enabled</u></b> for this group course.'
    },
    isUserCertificatePresent: function (userObj) {
      // console.log('userObj:' + JSON.stringify(userObj))
      if (userObj.UserCertificate !== undefined && userObj.UserCertificate !== 'undefined' && userObj.UserCertificate !== null && userObj.UserCertificate !== 'null' && userObj.UserCertificate !== '') {
        if ((userObj.UserCertificate.CertificatePDFUrl !== undefined && userObj.UserCertificate.CertificatePDFUrl !== 'undefined' && userObj.UserCertificate.CertificatePDFUrl !== null && userObj.UserCertificate.CertificatePDFUrl !== 'null' && userObj.UserCertificate.CertificatePDFUrl !== '') || (userObj.UserCertificate.CertificateImageUrl !== undefined && userObj.UserCertificate.CertificateImageUrl !== 'undefined' && userObj.UserCertificate.CertificateImageUrl !== null && userObj.UserCertificate.CertificateImageUrl !== 'null' && userObj.UserCertificate.CertificateImageUrl !== '')) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isGroupCourseCertificatePresent: function () {
      if (this.getSelectedGCMObjValue.Certificate !== undefined && this.getSelectedGCMObjValue.Certificate !== 'undefined' && this.getSelectedGCMObjValue.Certificate !== null && this.getSelectedGCMObjValue.Certificate !== 'null' && this.getSelectedGCMObjValue.Certificate !== '') {
        if (this.getSelectedGCMObjValue.Certificate.CertificateFile !== undefined && this.getSelectedGCMObjValue.Certificate.CertificateFile !== 'undefined' && this.getSelectedGCMObjValue.Certificate.CertificateFile !== null && this.getSelectedGCMObjValue.Certificate.CertificateFile !== 'null' && this.getSelectedGCMObjValue.Certificate.CertificateFile !== '') {
          if (!this.getSelectedGCMObjValue.DisableCertification) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    performUserClickAction: function (event, flagToUpdate, userObj, selectedOperation) {
      // AK: set current selected operation
      this.selectedOperation = selectedOperation
      // AK: Selected User object
      this.selectedUserObj = userObj
      this.prefixWarningString = 'Are you sure you want to '
      var middleString = ''
      switch (this.selectedOperation) {
        case 'enrollment':
          // AK: Bind prefix and post fix string
          middleString = userObj.Unenrolled === true ? 'enroll' : 'un-enroll'
          this.postWarningString = middleString + ' \'' + userObj.FirstName + ' ' + userObj.LastName + '\' from ' + this.selectedCohortObj.CohortName + ' cohort?'
          this.showConfirmationBox = true
          break
        case 'toolkit':
          // AK: Bind prefix and post fix string
          middleString = userObj.ViewToolkit === true ? 'remove' : 'allow'
          this.postWarningString = middleString + ' toolkit for \'' + userObj.FirstName + ' ' + userObj.LastName + '\'?'
          this.showConfirmationBox = true
          break
        case 'course':
          middleString = userObj.Disallowed === true ? 'allow' : 'disallow'
          this.postWarningString = middleString + ' course for \'' + userObj.FirstName + ' ' + userObj.LastName + '\'?'
          this.showConfirmationBox = true
          break
        case 'reset_data':
          this.postWarningString = ' reset data of \'' + userObj.FirstName + ' ' + userObj.LastName + '\'?'
          this.showConfirmationBox = true
          break
        case 'allow_disallow_certificate':
          if (this.isUserCertificatePresent(this.selectedUserObj)) {
            middleString = this.selectedUserObj.UserCertificate.AllowView === true ? 'disallow' : 'allow'
            this.postWarningString = middleString + ' certificate for \'' + userObj.FirstName + ' ' + userObj.LastName + '\'?'
            this.showConfirmationBox = true
          }
          break
        case 'preview_certificate':
          if (this.isUserCertificatePresent(this.selectedUserObj)) {
            this.openCertificateViewerOverlay = true
            this.$store.state.isOverlayVisible = true
          }
          break
        case 'generate_certificate':
          if (this.isGroupCourseCertificatePresent()) {
            this.postWarningString = 'generate the certificate for \'' + userObj.FirstName + ' ' + userObj.LastName + '\'?'
            this.showConfirmationBox = true
          }
          break
      }
    },
    performOperation (value) {
      // AK: Perform Enroll / Unenroll Operation based on user action option
      if (value) {
        this.showConfirmationBox = !value
        if (this.selectedCohortObj !== -1) {
          // AK: Check user selection
          switch (this.selectedOperation) {
            case 'enrollment':
              if (this.selectedUserObj.Unenrolled) {
                this.enrollParticipant()
              } else {
                this.unEnrollParticipant()
              }
              break
            case 'toolkit':
              this.updateToolkitStateOnServer()
              break
            case 'reset_data':
              this.resetParticipantData()
              break
            case 'course':
              this.updateCourseStateOnServer()
              break
            case 'allow_disallow_certificate':
              this.updateViewCertificateFlagOnServer()
              break
            case 'generate_certificate':
              this.generateUserCertificate()
              break
          }
        } else {
          console.log('Declined selected operation since Cohort Obj is null')
        }
      }
    },
    enrollParticipant: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      if (!has(this.selectedUserObj, 'IsFacilitator')) {
        this.selectedUserObj.IsFacilitator = false
      }
      participantService
        .enrollParticipant(
          storeObj.state.access_token,
          this.selectedUserObj.UserId,
          this.selectedCohortObj.CohortId,
          this.selectedUserObj.IsFacilitator
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            _this.resetValuesOnSuccess()
            _this.$emit('refreshList', true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    unEnrollParticipant: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .unEnrollParticipant(
          storeObj.state.access_token,
          this.selectedUserObj.UserId,
          this.selectedCohortObj.CohortId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            _this.resetValuesOnSuccess()
            _this.$emit('refreshList', true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of Confirmation overlay
      this.showConfirmationBox = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateToolkitStateOnServer: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .changeAllowToolkitFlag(
          storeObj.state.access_token,
          this.selectedUserObj.UserId,
          this.selectedCohortObj.CohortId,
          !this.selectedUserObj.ViewToolkit
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            _this.resetValuesOnSuccess()
            _this.$emit('refreshList', true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    generateUserCertificate: function () {
      var storeObj = this.$store
      this.$store.state.isLoading = true
      participantService
        .generateUserCertificateAtGroupCourse(
          storeObj.state.access_token,
          this.selectedUserObj.UserId,
          this.getSelectedGCMObjValue.GroupCourseMasterId,
          this.selectedCohortObj.CohortId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            this.resetValuesOnSuccess()
            this.showAlertDialog = true
            this.errorMsg = 'Certificate generated successfully for \'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\'.'
            this.$emit('refreshList', true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    updateViewCertificateFlagOnServer: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      var selectedUserIds = []
      selectedUserIds.push(this.selectedUserObj.UserId)
      participantService
        .updateUserViewCertificate(
          storeObj.state.access_token,
          this.selectedCohortObj.CohortId,
          !this.selectedUserObj.UserCertificate.AllowView,
          selectedUserIds
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            _this.resetValuesOnSuccess()
            _this.$emit('refreshList', true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    updateCourseStateOnServer: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .changeAllowCourseFlag(
          storeObj.state.access_token,
          this.selectedUserObj.UserId,
          this.selectedCohortObj.CohortId,
          this.selectedUserObj.Disallowed
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            _this.resetValuesOnSuccess()
            _this.$emit('refreshList', true)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    resetValuesOnSuccess: function () {
      this.isSelectedAll = false
    },
    resetParticipantData: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      var softDelete = true
      participantService
        .resetParticipantInfo(
          storeObj.state.access_token,
          this.selectedUserObj.UserId,
          this.selectedCohortObj.CohortId,
          this.getSelectedGCMObjValue.GroupCourseMasterId,
          softDelete
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after successful response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Refresh Participant List (Un-enrolllParticipantFilterBar file)
            _this.resetValuesOnSuccess()
            _this.$emit('refreshList', true)
            _this.showAlertDialog = true
            _this.errorMsg = '\'' + this.selectedUserObj.FirstName + ' ' + this.selectedUserObj.LastName + '\' Data reset successfully.'
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    }
  },
  components: {
    'choose-certificate-view-mode': ChooseCertificateViewMode,
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getAllParticipantsFromSelectedCohort: {
      get: function () {
        return this.userObjList
      }
    },
    getIsSelectedAllValue: {
      get: function () {
        return this.isSelectedAll
      },
      set: function (newValue) {
        this.selectedUserIdList = []
        if (!newValue) {
          this.$emit('userList', this.selectedUserIdList)
        } else {
          for (var i = 0; i < this.getAllParticipantsFromSelectedCohort.length; i++) {
            this.selectedUserIdList.push(this.getAllParticipantsFromSelectedCohort[i].UserId)
          }
          this.$emit('userList', this.selectedUserIdList)
        }
        this.isSelectedAll = newValue
      }
    },
    getSelectedGCMObjValue: {
      get: function () {
        return this.selectedGCMObj
      }
    },
    getSelectedUserIdList: {
      get: function () {
        return this.selectedUserIdList
      },
      set: function (newValue) {
        this.selectedUserIdList = newValue
        this.isSelectedAll = newValue.length === this.getAllParticipantsFromSelectedCohort.length && this.getAllParticipantsFromSelectedCohort.length > 0
        this.$emit('userList', this.selectedUserIdList)
      }
    }
  },
  watch: {}
}
</script>
<style scoped>
.float-right {
  float: right;
}
.opacity-1 {
  opacity: 1 !important;
}
.opacity-0Point2 {
  opacity: 0.2;
}
.margin-left-0px {
  margin-left: 0px !important;
}
.margin-right-0px {
  margin-right: 0px !important;
}
.font-size-13px {
  font-size: 13px;
}
.width-auto {
  width: auto !important;
}
.certification-state-indicator {
  font-size: 14px;
  color: #f39c12;
}
.cursor-default  {
  cursor: not-allowed !important;
}
.opacity-point-2 {
  opacity: 0.2;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.cursor-pointer {
  cursor: pointer;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.red-color-border {
  border: 1px solid red;
}
.green-color-border {
  border: 1px solid green;
}
.text-align-left {
  text-align: left;
}
.background-color-dark-grey {
  background-color: #bbb !important;
}
.background-color-light-grey {
  background-color: #ddd;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.margin-top-2Perc {
  margin-top: 2% !important;
}
.margin-top-3Perc {
  margin-top: 3% !important;
}
.width-7Point5Perc{
  width: 7.5% !important;
}
.width-8Perc {
  width: 8% !important;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.margin-top-1-perc {
  margin-top: 1%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.padding-right-0Perc{
  padding-right:0%;
}
.padding-left-0px {
  padding-left: 0px;
}
.padding-right-0px {
  padding-right: 0px;
}
.padding-left-0Perc{
  padding-left:0%;
}
.border-yellow{
  border:1px solid yellow;
}
.border-red{
  border:1px solid red;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.padding-left-1Point5Perc{
    padding-left: 1.5%;
}
.margin-left-0Point3Perc{
  margin-left:0.3%;
}
.margin-top-bottom-0Perc{
  margin-top:0%;
  margin-bottom:0%;
}
.width-1Perc{
  width: 1px;
}
.width-38Perc{
  width:38%;
}
.margin-bottom-3Perc{
  margin-bottom: 3%;
}
.padding-left-0Point5Perc{
  padding-left:0.5%;
}
.element-icon-width-height {
  width: 23px;
  height: 20px;
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext {
    visibility: hidden;
    width: 205px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
}

.text-break {
  word-break: break-all !important;
}
.tooltip1:hover .tooltiptext {
    visibility: visible;
}
.opacity-0Point5 {
  opacity: 0.5 !important;
}
.overflow-y-hidden{
  overflow-y: hidden !important;
}
.padding-bottom-18px{
  padding-bottom: 18px;
}
.text-decoration-underline {
  text-decoration: underline;
}
.opacity-0 {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/UnEnrollParticipantList.vue